const wait = t => new Promise(resolve => setTimeout(() => resolve(`waited for ${t/1000} second(s)`), t))
module.exports = wait
